"use client";

import { c as _c } from "react/compiler-runtime";
import { XIcon } from "@phosphor-icons/react/dist/ssr";
import Link from "next/link";
import { useCallback, useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { useCookieConsent } from "./cookie-consent-provider";
interface CategoryToggleProps {
  id: string;
  title: string;
  description: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}
function CategoryToggle(t0) {
  const $ = _c(23);
  const {
    id,
    title,
    description,
    checked,
    disabled,
    onChange
  } = t0;
  let t1;
  if ($[0] !== id || $[1] !== title) {
    t1 = <label htmlFor={id} className="font-mono text-sm font-semibold text-foreground">{title}</label>;
    $[0] = id;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== description) {
    t2 = <p className="font-mono text-xs leading-relaxed text-muted-foreground">{description}</p>;
    $[3] = description;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex flex-col gap-1">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== checked || $[9] !== onChange) {
    t4 = () => onChange(!checked);
    $[8] = checked;
    $[9] = onChange;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = `relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 ${checked ? "bg-primary" : "bg-muted"}`;
  const t6 = `pointer-events-none block size-5 rounded-full bg-background shadow-lg ring-0 transition-transform ${checked ? "translate-x-5" : "translate-x-0"}`;
  let t7;
  if ($[11] !== t6) {
    t7 = <span className={t6} />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== checked || $[14] !== disabled || $[15] !== id || $[16] !== t4 || $[17] !== t5 || $[18] !== t7) {
    t8 = <button type="button" id={id} role="switch" aria-checked={checked} disabled={disabled} onClick={t4} className={t5}>{t7}</button>;
    $[13] = checked;
    $[14] = disabled;
    $[15] = id;
    $[16] = t4;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t3 || $[21] !== t8) {
    t9 = <div className="flex items-start justify-between gap-4 rounded-md border border-border/50 p-4">{t3}{t8}</div>;
    $[20] = t3;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}
export function CookiePreferencesModal() {
  const $ = _c(46);
  const {
    showPreferences,
    closePreferences,
    savePreferences,
    consent
  } = useCookieConsent();
  const [analytics, setAnalytics] = useState(true);
  const [marketing, setMarketing] = useState(true);
  let t0;
  if ($[0] !== consent?.analytics || $[1] !== consent?.marketing || $[2] !== showPreferences) {
    t0 = () => {
      if (showPreferences) {
        setAnalytics(consent?.analytics ?? false);
        setMarketing(consent?.marketing ?? false);
      }
    };
    $[0] = consent?.analytics;
    $[1] = consent?.marketing;
    $[2] = showPreferences;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== consent || $[5] !== showPreferences) {
    t1 = [showPreferences, consent];
    $[4] = consent;
    $[5] = showPreferences;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  useEffect(t0, t1);
  let t2;
  if ($[7] !== analytics || $[8] !== marketing || $[9] !== savePreferences) {
    t2 = () => {
      savePreferences(analytics, marketing);
    };
    $[7] = analytics;
    $[8] = marketing;
    $[9] = savePreferences;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const handleSave = t2;
  let t3;
  if ($[11] !== savePreferences) {
    t3 = () => {
      savePreferences(true, true);
    };
    $[11] = savePreferences;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const handleAcceptAll = t3;
  let t4;
  let t5;
  if ($[13] !== closePreferences || $[14] !== showPreferences) {
    t4 = () => {
      const handleEscape = e => {
        if (e.key === "Escape" && showPreferences) {
          closePreferences();
        }
      };
      document.addEventListener("keydown", handleEscape);
      return () => document.removeEventListener("keydown", handleEscape);
    };
    t5 = [showPreferences, closePreferences];
    $[13] = closePreferences;
    $[14] = showPreferences;
    $[15] = t4;
    $[16] = t5;
  } else {
    t4 = $[15];
    t5 = $[16];
  }
  useEffect(t4, t5);
  if (!showPreferences) {
    return null;
  }
  let t6;
  if ($[17] !== closePreferences) {
    t6 = <button type="button" className="absolute inset-0 bg-background/80 backdrop-blur-sm" onClick={closePreferences} aria-label="Cerrar modal" />;
    $[17] = closePreferences;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h2 className="font-sans text-xl font-semibold text-foreground">Preferencias de Cookies</h2>;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div>{t7}<p className="mt-1 font-mono text-xs text-muted-foreground">Gestione sus preferencias de cookies.{" "}<Link href="/cookies" className="text-primary underline underline-offset-2 hover:text-primary/80">Política de cookies</Link></p></div>;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <XIcon className="size-5" />;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== closePreferences) {
    t10 = <div className="mb-6 flex items-start justify-between">{t8}<button type="button" onClick={closePreferences} className="rounded-md p-1 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground" aria-label="Cerrar">{t9}</button></div>;
    $[22] = closePreferences;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <CategoryToggle id="necessary" title="Cookies Necesarias" description="Esenciales para el funcionamiento del sitio web. No pueden desactivarse." checked={true} disabled={true} onChange={_temp} />;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== analytics) {
    t12 = <CategoryToggle id="analytics" title={"Cookies Anal\xEDticas"} description={"Nos ayudan a entender c\xF3mo interact\xFAan los visitantes con el sitio web mediante la recopilaci\xF3n de informaci\xF3n an\xF3nima. Incluye Google Analytics."} checked={analytics} onChange={setAnalytics} />;
    $[25] = analytics;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== marketing) {
    t13 = <CategoryToggle id="marketing" title="Cookies de Marketing" description={"Utilizadas para medir la efectividad de campa\xF1as publicitarias y proporcionar anuncios relevantes. Incluye Google Ads, Meta Pixel y LinkedIn Insight."} checked={marketing} onChange={setMarketing} />;
    $[27] = marketing;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <div className="flex flex-col gap-4">{t11}{t12}{t13}</div>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== handleSave) {
    t15 = <Button variant="outline" size="sm" onClick={handleSave}>Guardar preferencias</Button>;
    $[32] = handleSave;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== handleAcceptAll) {
    t16 = <Button variant="default" size="sm" onClick={handleAcceptAll}>Aceptar todo</Button>;
    $[34] = handleAcceptAll;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t15 || $[37] !== t16) {
    t17 = <div className="mt-6 flex flex-col gap-3 border-t border-border/50 pt-6 sm:flex-row sm:justify-end">{t15}{t16}</div>;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t10 || $[40] !== t14 || $[41] !== t17) {
    t18 = <div className="relative z-10 mx-4 max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-lg border border-border/50 bg-background p-6 shadow-2xl">{t10}{t14}{t17}</div>;
    $[39] = t10;
    $[40] = t14;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t18 || $[44] !== t6) {
    t19 = <div className="fixed inset-0 z-50 flex items-center justify-center">{t6}{t18}</div>;
    $[43] = t18;
    $[44] = t6;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
}
function _temp() {}